export const setCarwashSettings = async (context, carwashSettings) => {
  context.commit('SET_CARWASH_SETTINGS', carwashSettings)
}
